import { Chip, styled } from '@mui/material';
import defaultChipStyles from 'common/theme/chips/defaultChipStyles';

const StyledHourPickerOption = styled(Chip)(() => ({
  ...defaultChipStyles
}));

export default StyledHourPickerOption;
